import React from 'react';
import App from "./App";
// eslint-disable-next-line
import reportWebVitals from './reportWebVitals';

import 'react-toastify/dist/ReactToastify.min.css';
import './index.css';
import './app/i18n';

import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<React.StrictMode>
    <App/>
</React.StrictMode>,);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log());
